import { Component, Input } from '@angular/core';

import { CustomerMembershipStatus } from '../../../../../models/membership-enums';
import {
  getCustomerMembershipStatusDisplay,
  getMembershipStatusColorClass,
} from '../../../../../models/membership';


/**
 * Renders a customer-membership status as coloured text, with an optional
 * "- Pending Approval" suffix. Colour and text come from the shared
 * membership helpers the emailed-reports renderer also uses. The host is
 * display:contents (see the css) so no wrapper box is added.
 */
@Component({
  selector: 'app-membership-status-badge',
  templateUrl: './membership-status-badge.component.html',
  styleUrls: ['./membership-status-badge.component.css'],
})
export class MembershipStatusBadgeComponent {
  @Input() status: CustomerMembershipStatus;
  @Input() isPendingStaffApproval = false;

  public readonly getCustomerMembershipStatusDisplay = getCustomerMembershipStatusDisplay;
  public readonly getMembershipStatusColorClass = getMembershipStatusColorClass;
}
